<header class="navbar-expand-md">
  <div class="navbar bg-white">
    <div class="container-xl justify-content-start">
      <img ngSrc='./assets/images/user-mgmt-logo.png'
        [alt]="'admin.appName' | translate"
        height="32" width="32">
        <h1 class="m-0 mx-3 pe-4 text-dark">{{ 'admin.appName' | translate }}</h1>
        <ul class="navbar-nav ps-3 d-flex flex-row gap-3 sub-nav">

          @for (item of menuItems; track item) {
            <li
              class="nav-item"
              routerLinkActive="active"
              ariaCurrentWhenActive="page"
              >
              <a class="nav-link" [routerLink]="item.route">
                <span class="nav-link-title text-dark fw-bold">
                  {{ 'admin.menu.' + item.routeId | translate }}
                </span>
              </a>
            </li>
          }

        </ul>

      </div>
    </div>
  </header>
